//documentation: ninja-keys via context7 or https://github.com/ssleptsov/ninja-keys

import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"
import "ninja-keys"

// Connects to data-controller="command-palette"
export default class extends Controller {
  static values = {
    isAdmin: { type: Boolean, default: false },
    isDevelopment: { type: Boolean, default: false },
    isSignedIn: { type: Boolean, default: false }
  }

  connect() {
    // Track current submenu
    this.currentParent = null;
    
    this.allActions = [
      // {
      //   id: 'BookingsParent',
      //   title: 'Bookings',
      //   section: 'Bookings',
      //   hotkey: 'ctrl+A',
      //   children: ['GoToBookings', 'GoToBooking'],
      //   handler: () => {
      //     // Just keep menu open, selected event will handle the rest
      //     return { keepOpen: true }
      //   }
      // },
      {
        id: 'GoToProfile',
        title: 'Go to profile',
        section: 'Users',
        parent: 'UsersParent',
        keywords: 'users profile account settings',
        handler: () => {
          visit("/users/edit")
        }
      },
      {
        id: 'SignOut',
        title: 'Sign out',
        section: 'Users',
        parent: 'UsersParent',
        keywords: 'sign out log out logout signout',
        handler: () => {
          // Create and submit a form with DELETE method
          const form = document.createElement('form')
          form.method = 'POST'
          form.action = '/users/sign_out'
          
          const methodInput = document.createElement('input')
          methodInput.type = 'hidden'
          methodInput.name = '_method'
          methodInput.value = 'delete'
          form.appendChild(methodInput)
          
          const tokenInput = document.createElement('input')
          tokenInput.type = 'hidden'
          tokenInput.name = 'authenticity_token'
          tokenInput.value = document.querySelector('meta[name="csrf-token"]').content
          form.appendChild(tokenInput)
          
          document.body.appendChild(form)
          form.setAttribute('data-turbo', 'false')
          form.submit()
        },
        shouldShow: () => this.isSignedInValue
      },
      {
        id: 'SignIn',
        title: 'Sign in',
        section: 'Users',
        parent: 'UsersParent',
        keywords: 'sign in log in login signin',
        handler: () => {
          visit("/users/sign_in")
        },
        shouldShow: () => !this.isSignedInValue
      },
      {
        id: 'GoToBookings',
        title: 'Go to bookings list',
        section: 'Bookings',
        parent: 'BookingsParent',
        handler: () => {
          visit("/bookings")
        },
        shouldShow: () => this.isSignedInValue
      },
      {
        id: 'GoToBooking',
        title: 'Go to specific booking',
        section: 'Bookings',
        parent: 'BookingsParent',
        hotkey: 'ctrl+G',
        handler: () => {
          const bookingId = prompt('Enter booking ID or hashid:');
          if (bookingId && bookingId.trim()) {
            visit(`/bookings/${bookingId.trim()}`);
          }
        },
        shouldShow: () => this.isSignedInValue
      },
      // {
      //   id: 'Settings',
      //   title: 'Go to settings',
      //   hotkey: 'ctrl+S',
      //   handler: () => {
      //     visit("/settings")
      //   }
      // },
      // // Developer Tools parent section - admin only
      // {
      //   id: 'DevTools',
      //   title: 'Developer tools',
      //   hotkey: 'ctrl+D',
      //   section: 'Developer',
      //   children: ['EnableConsole', 'DisableConsole', 'DisableProfiling', 'EnableProfiling', 'SwitchToEnglish', 'SwitchToDutch', 'RemoveLanguage'],
      //   handler: () => {
      //     // Just keep menu open, selected event will handle the rest
      //     return { keepOpen: true }
      //   },
      //   // Show if admin OR in development environment
      //   shouldShow: () => this.isAdminValue || this.isDevelopmentValue
      // },
      {
        id: 'EnableConsole',
        title: 'Enable Rails console',
        hotkey: 'ctrl+`',
        parent: 'DevTools',
        handler: () => {
          const url = new URL(window.location.href);
          url.searchParams.set('console', 'true');
          visit(url.toString());
        },
        // Only show to admins when console is not active
        shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && !window.location.href.includes('console=true')
      },
      {
        id: 'DisableConsole',
        title: 'Disable Rails console',
        parent: 'DevTools',
        handler: () => {
          const url = new URL(window.location.href);
          url.searchParams.delete('console');
          visit(url.toString());
        },
        // Only show to admins when console is active
        shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && window.location.href.includes('console=true')
      },
      {
        id: 'DisableProfiling',
        title: 'Disable Rack Mini Profiler',
        parent: 'DevTools',
        handler: () => {
          const url = new URL(window.location.href);
          url.searchParams.set('pp', 'disable');
          visit(url.toString());
        },
        // Only show to admins when profiler is not disabled
        shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && !window.location.href.includes('pp=disable')
      },
      {
        id: 'EnableProfiling',
        title: 'Enable Rack Mini Profiler',
        parent: 'DevTools',
        handler: () => {
          const url = new URL(window.location.href);
          url.searchParams.delete('pp');
          visit(url.toString());
        },
        // Only show to admins when profiler is disabled
        shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && window.location.href.includes('pp=disable')
      },
      {
        id: 'SwitchToEnglish',
        title: 'Switch to English',
        parent: 'DevTools',
        keywords: 'language locale en',
        handler: () => {
          const url = new URL(window.location.href);
          url.searchParams.set('lang', 'en');
          visit(url.toString());
        },
        // Only show when not currently in English
        shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && !window.location.href.includes('lang=en')
      },
      {
        id: 'SwitchToDutch',
        title: 'Switch to Dutch',
        parent: 'DevTools',
        keywords: 'language locale nl',
        handler: () => {
          const url = new URL(window.location.href);
          url.searchParams.set('lang', 'nl');
          visit(url.toString());
        },
        // Only show when not currently in Dutch
        shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && !window.location.href.includes('lang=nl')
      },
      {
        id: 'SwitchToGerman',
        title: 'Switch to German',
        parent: 'DevTools',
        keywords: 'language locale de deutsch',
        handler: () => {
          const url = new URL(window.location.href);
          url.searchParams.set('lang', 'de');
          visit(url.toString());
        },
        // Only show when not currently in German
        shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && !window.location.href.includes('lang=de')
      },
      {
        id: 'RemoveLanguage',
        title: 'Use default language',
        parent: 'DevTools',
        handler: () => {
          const url = new URL(window.location.href);
          url.searchParams.delete('lang');
          visit(url.toString());
        },
        // Only show when a language parameter is present
        shouldShow: () => (this.isAdminValue || this.isDevelopmentValue) && 
          (window.location.href.includes('lang=en') || window.location.href.includes('lang=nl') || window.location.href.includes('lang=de'))
      },
      {
        id: 'GoToMissionControl',
        title: 'Go to Mission Control',
        section: 'Developer',
        parent: 'DevTools',
        keywords: 'mission control background jobs',
        handler: () => {
          visit("/jobs")
        },
        shouldShow: () => (this.isAdminValue || this.isDevelopmentValue)
      },
      {
        id: 'GoToLookbook',
        title: 'Go to Lookbook',
        section: 'Developer',
        parent: 'DevTools',
        keywords: 'lookbook view components viewcomponent',
        handler: () => {
          visit("/lookbook")
        },
        shouldShow: () => (this.isAdminValue || this.isDevelopmentValue)
      },
    ]

    // Start with empty list
    this.element.data = []

    // Handle selection of parent items
    this.element.addEventListener('selected', (event) => {
      if (event.detail.action?.children) {
        this.currentParent = event.detail.action.id
        this.updateVisibleActions()
      }
    })

    // Handle search and maintain submenu state
    this.element.addEventListener('change', (event) => {
      this.updateVisibleActions(event.detail.search)
    })
  }

  // Single method to update visible actions based on current state
  updateVisibleActions(search = '') {
    search = search.trim()
    
    if (this.currentParent && search === '') {
      // In submenu with no search - show children
      this.element.data = this.allActions
        .filter(action => action.parent === this.currentParent)
        .filter(action => !action.shouldShow || action.shouldShow())
    } 
    else if (search === '') {
      // At root with no search - show nothing
      this.element.data = []
      this.currentParent = null
    } 
    else {
      // With search - show matching items
      this.element.data = this.allActions
        .filter(action => !action.shouldShow || action.shouldShow())
        .filter(action => {
          const searchLower = search.toLowerCase();
          return action.title.toLowerCase().includes(searchLower) || 
                 (action.keywords && action.keywords.toLowerCase().includes(searchLower));
        })
    }
  }
}
